import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router';
import RouterPropTypes from 'react-router-prop-types';

import OrderList from '../OrderList';
import { paramsToQueryIdentifier } from '../../../util/query';
import { modelOf } from '../../../prop-types';
import OrderStore from '../../../store/OrderStore';
import ContentForState from '../../loader/ContentForState';
import Paginator from '../../common/Paginator';
import { parse, stringify } from '../../../util/queryString';
import RequestState from '../../../types/RequestState';
import RecurringOrderStore from '../../../store/RecurringOrderStore';

@observer
export class MainOrderList extends Component {
  state = {
    searchParameters: '',
    removeError: null
  };

  componentDidMount() {
    this.loadOrders();
  }

  componentDidUpdate() {
    if (this.state.searchParameters !== stringify(this.getQueryParameters())) {
      this.setState(
        () => ({
          searchParameters: stringify(this.getQueryParameters())
        }),
        this.loadOrders
      );
    }
  }

  loadOrders = () => {
    const store = this.getStore();
    if (
      !this.getCurrentResult() &&
      store.orderQueryStates.get(this.getQueryIdentifier()) !==
        RequestState.LOADING
    ) {
      store.loadOrders(this.getQueryParameters());
    }
  };

  onRemoveClick = (id) => {
    const { recurringOrderStore } = this.props;

    recurringOrderStore
      .removeOrder(id)
      .then(() => {
        recurringOrderStore.loadOrders(this.getQueryParameters());
        this.setState({ removeError: null });
      })
      .catch((error) =>
        this.setState({
          removeError: error,
          requestId: this.state.requestId + 1
        })
      );
  };

  getStore = () => {
    const { orderStore, recurringOrderStore, useRecurringOrders } = this.props;

    return useRecurringOrders ? recurringOrderStore : orderStore;
  };

  getQueryParameters = () => {
    const {
      location: { search }
    } = this.props;

    const params = {
      page: 1,
      resultsPerPage: this.props.resultsPerPage,
      ...parse(search)
    };
    params.page = Number(params.page);

    return params;
  };

  getQueryIdentifier = () => {
    return paramsToQueryIdentifier(this.getQueryParameters());
  };

  getCurrentResult = () => {
    const store = this.getStore();

    return store.orderQueryResults.get(this.getQueryIdentifier());
  };

  getOrderPageItems = () => {
    const page = this.getCurrentResult();
    return page ? page.data : [];
  };

  getOrderPageItemCount = () => {
    const page = this.getCurrentResult();
    return page ? page.total : 0;
  };

  getPaginator = () => {
    const { location } = this.props;
    const {
      last_page: lastPage,
      current_page: currentPage
    } = this.getCurrentResult();

    let searchTemplate;
    const regex = /page=(\d+?)(?=(&|$))/;
    const pageParameter = `page=:page`;
    if (location.search.charAt(0) !== '?') {
      searchTemplate = location.search + '?' + pageParameter;
    } else {
      searchTemplate = location.search.match(regex)
        ? location.search.replace(regex, pageParameter)
        : location.search + '&' + pageParameter;
    }
    const pathTemplate = location.pathname + searchTemplate;

    return (
      <Paginator
        pathTemplate={pathTemplate}
        currentPage={currentPage}
        lastPage={lastPage}
        pagesToShow={5}
      />
    );
  };

  render() {
    const { singlePage, useRecurringOrders } = this.props;
    const store = this.getStore();
    const state = store.orderQueryStates.get(this.getQueryIdentifier());
    if (this.props.onOrderCount) {
      this.props.onOrderCount(this.getOrderPageItemCount());
    }
    // TODO tän komponentin stateen orders, jotta päivittyy listaus poiston jälkeen
    return (
      <div className="MainOrderList">
        <ContentForState
          state={state}
          forLoaded={() => (
            <Fragment>
              <OrderList
                orders={this.getOrderPageItems()}
                useRecurringOrders={useRecurringOrders}
                onRemoveClick={this.onRemoveClick}
              />
              {!singlePage &&
                this.getOrderPageItemCount() > 0 &&
                this.getPaginator()}
            </Fragment>
          )}
        />
      </div>
    );
  }
}

MainOrderList.propTypes = {
  orderStore: modelOf(OrderStore).isRequired,
  recurringOrderStore: modelOf(RecurringOrderStore).isRequired,
  location: RouterPropTypes.location.isRequired,
  resultsPerPage: PropTypes.number,
  singlePage: PropTypes.bool,
  onOrderCount: PropTypes.func,
  useRecurringOrders: PropTypes.bool
};

MainOrderList.defaultProps = {
  resultsPerPage: 5
};

export default withRouter(
  inject('orderStore', 'recurringOrderStore')(MainOrderList)
);



// WEBPACK FOOTER //
// ./src/components/order/MainOrderList/index.jsx